<template>
    <div
        class="md-search template1"
        :class="{
            [layoutState]: true,
            mobile: isMobile,
            'hide-below': hideBelow,
            'map-search-hide': !showSearchBar,
            'module-in-featured-area-search': page.pageKey === 'featured-area-search',
            'mg-container': page.pageKey === 'featured-area-search'
        }"
        :style="{ marginBottom, paddingTop, ...style }"
        v-if="listingSourceReady"
    >
        <component
            :is="mdSearchBar"
            ref="listingSearch"
            :searchBarOnly="false"
            v-show="showSearchBar"
            @conditionChange="conditionChange"
            :propsToData="dataToSearchBar"
        />
        <SearchResult
            cls="show-search mg-magtop-40 all-screen"
            :hideBelow="hideBelow"
            :mapSearchText="mapSearchText"
            :hideSearchChoose="hideSearchChoose"
            :mapDrawTip="mapDrawTip"
            :showSchool="showSchool"
            :propsToData="dataToSearchResult"
            ref="result"
        />
    </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import Core from '../index';
import { colorBlock } from '../../defaultSpacing';
import searchBarMixin from '../../md-search-bar-mixin';
export default {
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return `${(this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) || 0}px`;
        },
        marginBottom() {
            return `${(this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) || 0}px`;
        }
    },
    data: function() {
        return {
            ...colorBlock
        };
    },
    mixins: [Core, searchBarMixin('template1')],
    components: {
        SearchResult: defineAsyncComponent(() =>
            import(
                /*webpackChunkName: 'components/search-result/template1' */
                '../../../components/search-result/template1/index.vue'
            ))
    }
};
</script>
<style lang="scss">
.md-search.map.template1 {
    display: flex;
    flex-direction: column;
    flex: 1;
    .md-search-result:not(.big-map) {
        flex: 1;
    }
    &.mobile {
        .md-search-result {
            height: auto !important;
            .map-result-container {
                height: auto !important;
            }
        }
    }
}
.md-search.map.hide-below ~ * {
    display: none;
}
.map-search-hide .map-tool.search {
    display: none;
}

.md-search.template1.map.hide-below {
    margin-bottom: 0 !important;
    .comp-pagination {
        margin-bottom: 60px;
    }
}
</style>
